import { store } from "./redux/store";
import jwt_decode from "jwt-decode";
import { logout } from "./redux/features/authVerification/authSlice";

// Do something before request is sent
export const parseJwt = (token) => {
  try {
    return jwt_decode(token);
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const checkJwtExp = () => {
  const {
    auth: { token, userData },
  } = store.getState();
  if (userData) {
    const decodedJwt = parseJwt(token);
    console.log(
      { token, userData, decodedJwt, now: Date.now() },
      "this is check jwtExp log"
    );
    if (!decodedJwt?.exp) {
      store.dispatch(logout());
      return;
    }
    if (decodedJwt.exp * 1000 < Date.now()) {
      console.log("decodeJwt is login me out");
      store.dispatch(logout());
    }
  }
};

export function requestInterceptor(config) {
  checkJwtExp();
  const {
    auth: { token },
  } = store.getState();
  // if (config.url === "/user/verifyOtp" || config.url === "/user/reset") {
  //   config.headers = {
  //     Authorization: `proctorme ${otpToken}`,
  //   };
  //   return config;
  // }

  if (token && token !== "") {
    checkJwtExp();
    config.headers = {
      Authorization: `Proctorme ${token}`,
    };
    return config;
  }
  return config;
}
